import { useTranslation } from 'next-i18next';
import * as React from 'react';

import { Icon } from '../../design-system/Icon';

/**
 * Full-page loading spinner to match other apps, which creates a seamless experience for signed-in users.
 *
 * @returns A Full page loading page with a spinner aligned center.
 */
export function FullPageLoader() {
  const { t } = useTranslation();
  return (
    <div className='flex content-center justify-center h-screen items-center dark:bg-gray-50 bg-white'>
      <div className='flex content-center justify-center items-center h-full w-full' style={{ color: '#FF3D4D' }}>
        <Icon animated={true} aria-label={t('loading')} name='Spinner' size='2xl' />
      </div>
    </div>
  );
}
